import { ISelectableObject } from "../../../../../../domain/editableFormat/objects";
import { ISelectableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import { StandardTextDrawableObjectTranslator } from "./StandardTextDrawableObjectTranslator";

export class SelectableObjectTranslator<TObject extends ISelectableObject, TBean extends ISelectableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new StandardTextDrawableObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
    // TODO: 独自要素の変換.
  }

  overwriteBean(source: TBean, object: TObject): void {
    source["@type"] = "1";
    // TODO: 独自要素の変換.
  }
}
